// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `b, strong {
  font-weight: bold;
}

dfn {
  font-style: italic;
}

h1 {
  margin: .67em 0;
  font-size: 2em;
}

small {
  font-size: 80%;
}

code, kbd, pre, samp {
  font-family: monospace;
  font-size: 1em;
}

* {
  box-sizing: border-box;
}

body {
  color: #333;
  background-color: #131313;
  min-height: 100%;
  margin: 0;
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 20px;
}

img {
  vertical-align: middle;
  max-width: 100%;
  display: block;
  margin-left: auto;
  margin-right: auto;
  border: 0;
}

h1, h2, h3, h4, h5, h6 {
  margin-bottom: 10px;
  font-weight: bold;
}

h1 {
  margin-top: 20px;
  font-size: 38px;
  line-height: 44px;
}

h2 {
  margin-top: 20px;
  font-size: 32px;
  line-height: 36px;
}

h3 {
  margin-top: 20px;
  font-size: 24px;
  line-height: 30px;
}

h4 {
  margin-top: 10px;
  font-size: 18px;
  line-height: 24px;
}

h5 {
  margin-top: 10px;
  font-size: 14px;
  line-height: 20px;
}

h6 {
  margin-top: 10px;
  font-size: 12px;
  line-height: 18px;
}

p {
  margin-top: 0;
  margin-bottom: 10px;
}


:root {
  --white: #fff;
  --silver: #bcbcbc;
  --seal-brown: #131313;
  --container-size: 1160px;
  --letter-spacing-3: -.03em;
  --letter-spacing-2: -.02em;
  --granite-gray: #595959;
  --tints: #e7d1b0;
  --gordons-green-bright: #323332;
  --approx-nero: #181818;
  --eerie-black: #1d1d1d;
  --red: #ff8a5e;
  --gradient-l: rgba(231, 209, 176, 0);
  --gradient-r: rgba(231, 209, 176, .15);
  --white-2: white;
  --black: black;
}

h3 {
  color: var(--white);
  letter-spacing: -.02em;
  margin-top: 0;
  margin-bottom: 40px;
  font-family: Dm sans, sans-serif;
  font-size: 48px;
  font-weight: 700;
  line-height: 56px;
}

p {
  color: var(--silver);
  margin-bottom: 0;
  font-family: Inter, sans-serif;
  font-size: 18px;
  line-height: 28px;
}

.body {
  background-color: var(--seal-brown);
}

.container {
  max-width: var(--container-size);
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
}

.h1 {
  color: var(--white);
  letter-spacing: var(--letter-spacing-3);
  margin-top: 0;
  margin-bottom: 0;
  font-family: Dm sans, sans-serif;
  font-size: 64px;
  font-weight: 700;
  line-height: 72px;
}


.h1.style-guide-heading {
  text-align: center;
}

.h2 {
  color: var(--white);
  letter-spacing: var(--letter-spacing-2);
  margin-top: 0;
  margin-bottom: 0;
  font-family: Dm sans, sans-serif;
  font-size: 56px;
  font-weight: 700;
  line-height: 64px;
}



.h3 {
  color: var(--white);
  letter-spacing: var(--letter-spacing-2);
  margin-top: 0;
  margin-bottom: 0;
  font-family: Dm sans, sans-serif;
  font-size: 48px;
  font-weight: 700;
  line-height: 56px;
}

.h4 {
  color: var(--white);
  margin-top: 0;
  margin-bottom: 0;
  font-family: Dm sans, sans-serif;
  font-size: 44px;
  font-weight: 700;
  line-height: 52px;
}

.sub-h1 {
  color: var(--white);
  margin-top: 0;
  margin-bottom: 0;
  font-family: Dm sans, sans-serif;
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
}

.body-01 {
  color: var(--white);
  font-family: Inter, sans-serif;
  font-size: 18px;
  line-height: 28px;
}


.body-02 {
  color: var(--white);
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.body-03 {
  color: var(--white);
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
}

.button-1 {
  border: 1px solid var(--granite-gray);
  background-image: linear-gradient(180deg, var(--gradient-l), var(--gradient-r));
  border-radius: 6px;
  justify-content: center;
  align-items: center;
  padding: 15px 24px;
  text-decoration: none;
  transition: all .3s;
  display: flex;
  width: 160px;
  text-align: center;
  z-index: 100000;
}

.button-1:hover {
  background-image: linear-gradient(to right, var(--gradient-r), var(--gradient-l));
}


.button-1-text {
  color: var(--white);
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
}

.button-2 {
  grid-column-gap: 8px;
  grid-row-gap: 8px;
  border: 1px solid var(--granite-gray);
  background-color: var(--approx-nero);
  border-radius: 6px;
  justify-content: center;
  align-items: center;
  padding: 15px 24px;
  text-decoration: none;
  display: flex;
  width: 160px;
  text-align: center;
}


.button-2:hover {
  background-color: var(--seal-brown);
  background-image: linear-gradient(to right, var(--gradient-r), var(--gradient-l));
}

.button-2-text {
  color: var(--white);
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;

}

.sign-up-btn {
  border: 1px solid var(--granite-gray);
  background-color: var(--approx-nero);
  background-image: linear-gradient(to bottom, var(--gradient-l), var(--gradient-r));
  color: var(--white);
  border-radius: 6px;
  padding: 11px 24px;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  transition: all .2s;
  text-decoration: none;
  z-index: 1000000;
}

.sign-up-btn:hover {
  background-image: linear-gradient(45deg, var(--gradient-l), var(--gradient-r));
}

.spacing {
  margin-top: 30px;
}

@media screen and (max-width: 991px) {
  h3 {
    margin-bottom: 24px;
    font-size: 40px;
    line-height: 48px;
  }

  ul {
    margin-bottom: 40px;
  }

  li {
    margin-bottom: 10px;
    font-size: 18px;
    line-height: 24px;
  }

  .container {
    margin-left: 60px;
    margin-right: 60px;
  }

  .h1 {
    font-size: 58px;
    line-height: 66px;
  }

  .h2 {
    font-size: 42px;
    line-height: 60px;
  }


  .buttons {
    margin-top: 100px;
  }

  .buttons-wrap {
    margin-top: 60px;
  }

  .button-3 {
    padding-left: 100px;
    padding-right: 100px;
  }
}

@media screen and (max-width: 767px) {
  h3 {
    margin-bottom: 20px;
    font-size: 32px;
    line-height: 40px;
  }

  .container {
    margin-left: 40px;
    margin-right: 40px;
  }


  .h1 {
    font-size: 52px;
    line-height: 60px;
  }

  .h2 {
    font-size: 36px;
    line-height: 56px;
  }

  .h3 {
    font-size: 44px;
    line-height: 52px;
  }

  .h4 {
    font-size: 40px;
    line-height: 48px;
  }

  .buttons-wrap {
    grid-column-gap: 28px;
    grid-row-gap: 28px;
  }

  .button-1, .button-2 {
    padding-left: 20px;
    padding-right: 20px;
  }

  .mobile-margin-top-10 {
    margin-top: 10px;
  }
}

@media screen and (max-width: 479px) {
  h3 {
    margin-bottom: 16px;
    font-size: 24px;
    line-height: 32px;
  }

  p {
    font-size: 16px;
    line-height: 22px;
  }

  .container {
    margin-left: 20px;
    margin-right: 20px;
  }

  .typography-wrap {
    grid-column-gap: 20px;
    grid-row-gap: 20px;
    margin-top: 40px;
  }

  .h1 {
    font-size: 44px;
    line-height: 52px;
  }

  .h2 {
    font-size: 32px;
    line-height: 48px;
  }

  .body-01 {
    line-height: 24px;
  }

  .body-02 {
    line-height: 22px;
  }

  .buttons {
    margin-top: 80px;
  }

  .buttons-wrap {
    grid-column-gap: 20px;
    grid-row-gap: 20px;
    margin-top: 40px;
  }

  .button-1 {
    padding: 14px 16px;
  }

  .button-2 {
    grid-column-gap: 6px;
    grid-row-gap: 6px;
    padding: 14px 16px;
  }

  .button-3 {
    padding: 15px 80px;
  }
}

@font-face {
  font-family: 'Dm sans';
  src: url('https://assets.website-files.com/65dc4e0e18107f1438dea07c/65dc4e0e18107f1438dea0ae_DMSans_18pt-Regular.ttf') format('truetype');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Dm sans';
  src: url('https://assets.website-files.com/65dc4e0e18107f1438dea07c/65dc4e0e18107f1438dea0ad_DMSans_18pt-SemiBold.ttf') format('truetype');
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Dm sans';
  src: url('https://assets.website-files.com/65dc4e0e18107f1438dea07c/65dc4e0e18107f1438dea0ac_DMSans_18pt-Medium.ttf') format('truetype');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Dm sans';
  src: url('https://assets.website-files.com/65dc4e0e18107f1438dea07c/65dc4e0e18107f1438dea0a9_DMSans_18pt-Bold.ttf') format('truetype');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Inter';
  src: url('https://assets.website-files.com/65dc4e0e18107f1438dea07c/65dc4e0e18107f1438dea0af_Inter-Medium.ttf') format('truetype');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Inter';
  src: url('https://assets.website-files.com/65dc4e0e18107f1438dea07c/65dc4e0e18107f1438dea0b2_Inter-Regular.ttf') format('truetype');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Inter';
  src: url('https://assets.website-files.com/65dc4e0e18107f1438dea07c/65dc4e0e18107f1438dea0b0_Inter-Bold.ttf') format('truetype');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Inter';
  src: url('https://assets.website-files.com/65dc4e0e18107f1438dea07c/65dc4e0e18107f1438dea0b1_Inter-SemiBold.ttf') format('truetype');
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;EACT,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,iBAAiB;EACjB,qBAAqB;EACrB,wBAAwB;EACxB,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,gBAAgB;EAChB,+BAA+B;EAC/B,sBAAsB;EACtB,sBAAsB;EACtB,cAAc;EACd,oCAAoC;EACpC,sCAAsC;EACtC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;;;AAIA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;AACnB;;;AAGA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,+EAA+E;EAC/E,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iFAAiF;AACnF;;;AAGA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,qCAAqC;EACrC,oCAAoC;EACpC,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;;AAGA;EACE,mCAAmC;EACnC,iFAAiF;AACnF;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;;AAEnB;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,kFAAkF;EAClF,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,8EAA8E;AAChF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;;EAGA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;;EAGA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,sBAAsB;EACtB,yIAAyI;EACzI,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,0IAA0I;EAC1I,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,wIAAwI;EACxI,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,sIAAsI;EACtI,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,kIAAkI;EAClI,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mIAAmI;EACnI,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,gIAAgI;EAChI,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,oIAAoI;EACpI,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":["b, strong {\n  font-weight: bold;\n}\n\ndfn {\n  font-style: italic;\n}\n\nh1 {\n  margin: .67em 0;\n  font-size: 2em;\n}\n\nsmall {\n  font-size: 80%;\n}\n\ncode, kbd, pre, samp {\n  font-family: monospace;\n  font-size: 1em;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  color: #333;\n  background-color: #131313;\n  min-height: 100%;\n  margin: 0;\n  font-family: Arial, sans-serif;\n  font-size: 14px;\n  line-height: 20px;\n}\n\nimg {\n  vertical-align: middle;\n  max-width: 100%;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  border: 0;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  margin-bottom: 10px;\n  font-weight: bold;\n}\n\nh1 {\n  margin-top: 20px;\n  font-size: 38px;\n  line-height: 44px;\n}\n\nh2 {\n  margin-top: 20px;\n  font-size: 32px;\n  line-height: 36px;\n}\n\nh3 {\n  margin-top: 20px;\n  font-size: 24px;\n  line-height: 30px;\n}\n\nh4 {\n  margin-top: 10px;\n  font-size: 18px;\n  line-height: 24px;\n}\n\nh5 {\n  margin-top: 10px;\n  font-size: 14px;\n  line-height: 20px;\n}\n\nh6 {\n  margin-top: 10px;\n  font-size: 12px;\n  line-height: 18px;\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 10px;\n}\n\n\n:root {\n  --white: #fff;\n  --silver: #bcbcbc;\n  --seal-brown: #131313;\n  --container-size: 1160px;\n  --letter-spacing-3: -.03em;\n  --letter-spacing-2: -.02em;\n  --granite-gray: #595959;\n  --tints: #e7d1b0;\n  --gordons-green-bright: #323332;\n  --approx-nero: #181818;\n  --eerie-black: #1d1d1d;\n  --red: #ff8a5e;\n  --gradient-l: rgba(231, 209, 176, 0);\n  --gradient-r: rgba(231, 209, 176, .15);\n  --white-2: white;\n  --black: black;\n}\n\nh3 {\n  color: var(--white);\n  letter-spacing: -.02em;\n  margin-top: 0;\n  margin-bottom: 40px;\n  font-family: Dm sans, sans-serif;\n  font-size: 48px;\n  font-weight: 700;\n  line-height: 56px;\n}\n\np {\n  color: var(--silver);\n  margin-bottom: 0;\n  font-family: Inter, sans-serif;\n  font-size: 18px;\n  line-height: 28px;\n}\n\n.body {\n  background-color: var(--seal-brown);\n}\n\n.container {\n  max-width: var(--container-size);\n  margin-left: auto;\n  margin-right: auto;\n  z-index: 1;\n}\n\n.h1 {\n  color: var(--white);\n  letter-spacing: var(--letter-spacing-3);\n  margin-top: 0;\n  margin-bottom: 0;\n  font-family: Dm sans, sans-serif;\n  font-size: 64px;\n  font-weight: 700;\n  line-height: 72px;\n}\n\n\n.h1.style-guide-heading {\n  text-align: center;\n}\n\n.h2 {\n  color: var(--white);\n  letter-spacing: var(--letter-spacing-2);\n  margin-top: 0;\n  margin-bottom: 0;\n  font-family: Dm sans, sans-serif;\n  font-size: 56px;\n  font-weight: 700;\n  line-height: 64px;\n}\n\n\n\n.h3 {\n  color: var(--white);\n  letter-spacing: var(--letter-spacing-2);\n  margin-top: 0;\n  margin-bottom: 0;\n  font-family: Dm sans, sans-serif;\n  font-size: 48px;\n  font-weight: 700;\n  line-height: 56px;\n}\n\n.h4 {\n  color: var(--white);\n  margin-top: 0;\n  margin-bottom: 0;\n  font-family: Dm sans, sans-serif;\n  font-size: 44px;\n  font-weight: 700;\n  line-height: 52px;\n}\n\n.sub-h1 {\n  color: var(--white);\n  margin-top: 0;\n  margin-bottom: 0;\n  font-family: Dm sans, sans-serif;\n  font-size: 24px;\n  font-weight: 500;\n  line-height: 32px;\n}\n\n.body-01 {\n  color: var(--white);\n  font-family: Inter, sans-serif;\n  font-size: 18px;\n  line-height: 28px;\n}\n\n\n.body-02 {\n  color: var(--white);\n  font-family: Inter, sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.body-03 {\n  color: var(--white);\n  font-family: Inter, sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 18px;\n}\n\n.button-1 {\n  border: 1px solid var(--granite-gray);\n  background-image: linear-gradient(180deg, var(--gradient-l), var(--gradient-r));\n  border-radius: 6px;\n  justify-content: center;\n  align-items: center;\n  padding: 15px 24px;\n  text-decoration: none;\n  transition: all .3s;\n  display: flex;\n  width: 160px;\n  text-align: center;\n  z-index: 100000;\n}\n\n.button-1:hover {\n  background-image: linear-gradient(to right, var(--gradient-r), var(--gradient-l));\n}\n\n\n.button-1-text {\n  color: var(--white);\n  font-family: Inter, sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18px;\n}\n\n.button-2 {\n  grid-column-gap: 8px;\n  grid-row-gap: 8px;\n  border: 1px solid var(--granite-gray);\n  background-color: var(--approx-nero);\n  border-radius: 6px;\n  justify-content: center;\n  align-items: center;\n  padding: 15px 24px;\n  text-decoration: none;\n  display: flex;\n  width: 160px;\n  text-align: center;\n}\n\n\n.button-2:hover {\n  background-color: var(--seal-brown);\n  background-image: linear-gradient(to right, var(--gradient-r), var(--gradient-l));\n}\n\n.button-2-text {\n  color: var(--white);\n  font-family: Inter, sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18px;\n\n}\n\n.sign-up-btn {\n  border: 1px solid var(--granite-gray);\n  background-color: var(--approx-nero);\n  background-image: linear-gradient(to bottom, var(--gradient-l), var(--gradient-r));\n  color: var(--white);\n  border-radius: 6px;\n  padding: 11px 24px;\n  font-family: Inter, sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18px;\n  transition: all .2s;\n  text-decoration: none;\n  z-index: 1000000;\n}\n\n.sign-up-btn:hover {\n  background-image: linear-gradient(45deg, var(--gradient-l), var(--gradient-r));\n}\n\n.spacing {\n  margin-top: 30px;\n}\n\n@media screen and (max-width: 991px) {\n  h3 {\n    margin-bottom: 24px;\n    font-size: 40px;\n    line-height: 48px;\n  }\n\n  ul {\n    margin-bottom: 40px;\n  }\n\n  li {\n    margin-bottom: 10px;\n    font-size: 18px;\n    line-height: 24px;\n  }\n\n  .container {\n    margin-left: 60px;\n    margin-right: 60px;\n  }\n\n  .h1 {\n    font-size: 58px;\n    line-height: 66px;\n  }\n\n  .h2 {\n    font-size: 42px;\n    line-height: 60px;\n  }\n\n\n  .buttons {\n    margin-top: 100px;\n  }\n\n  .buttons-wrap {\n    margin-top: 60px;\n  }\n\n  .button-3 {\n    padding-left: 100px;\n    padding-right: 100px;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  h3 {\n    margin-bottom: 20px;\n    font-size: 32px;\n    line-height: 40px;\n  }\n\n  .container {\n    margin-left: 40px;\n    margin-right: 40px;\n  }\n\n\n  .h1 {\n    font-size: 52px;\n    line-height: 60px;\n  }\n\n  .h2 {\n    font-size: 36px;\n    line-height: 56px;\n  }\n\n  .h3 {\n    font-size: 44px;\n    line-height: 52px;\n  }\n\n  .h4 {\n    font-size: 40px;\n    line-height: 48px;\n  }\n\n  .buttons-wrap {\n    grid-column-gap: 28px;\n    grid-row-gap: 28px;\n  }\n\n  .button-1, .button-2 {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n\n  .mobile-margin-top-10 {\n    margin-top: 10px;\n  }\n}\n\n@media screen and (max-width: 479px) {\n  h3 {\n    margin-bottom: 16px;\n    font-size: 24px;\n    line-height: 32px;\n  }\n\n  p {\n    font-size: 16px;\n    line-height: 22px;\n  }\n\n  .container {\n    margin-left: 20px;\n    margin-right: 20px;\n  }\n\n  .typography-wrap {\n    grid-column-gap: 20px;\n    grid-row-gap: 20px;\n    margin-top: 40px;\n  }\n\n  .h1 {\n    font-size: 44px;\n    line-height: 52px;\n  }\n\n  .h2 {\n    font-size: 32px;\n    line-height: 48px;\n  }\n\n  .body-01 {\n    line-height: 24px;\n  }\n\n  .body-02 {\n    line-height: 22px;\n  }\n\n  .buttons {\n    margin-top: 80px;\n  }\n\n  .buttons-wrap {\n    grid-column-gap: 20px;\n    grid-row-gap: 20px;\n    margin-top: 40px;\n  }\n\n  .button-1 {\n    padding: 14px 16px;\n  }\n\n  .button-2 {\n    grid-column-gap: 6px;\n    grid-row-gap: 6px;\n    padding: 14px 16px;\n  }\n\n  .button-3 {\n    padding: 15px 80px;\n  }\n}\n\n@font-face {\n  font-family: 'Dm sans';\n  src: url('https://assets.website-files.com/65dc4e0e18107f1438dea07c/65dc4e0e18107f1438dea0ae_DMSans_18pt-Regular.ttf') format('truetype');\n  font-weight: 400;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Dm sans';\n  src: url('https://assets.website-files.com/65dc4e0e18107f1438dea07c/65dc4e0e18107f1438dea0ad_DMSans_18pt-SemiBold.ttf') format('truetype');\n  font-weight: 600;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Dm sans';\n  src: url('https://assets.website-files.com/65dc4e0e18107f1438dea07c/65dc4e0e18107f1438dea0ac_DMSans_18pt-Medium.ttf') format('truetype');\n  font-weight: 500;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Dm sans';\n  src: url('https://assets.website-files.com/65dc4e0e18107f1438dea07c/65dc4e0e18107f1438dea0a9_DMSans_18pt-Bold.ttf') format('truetype');\n  font-weight: 700;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Inter';\n  src: url('https://assets.website-files.com/65dc4e0e18107f1438dea07c/65dc4e0e18107f1438dea0af_Inter-Medium.ttf') format('truetype');\n  font-weight: 500;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Inter';\n  src: url('https://assets.website-files.com/65dc4e0e18107f1438dea07c/65dc4e0e18107f1438dea0b2_Inter-Regular.ttf') format('truetype');\n  font-weight: 400;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Inter';\n  src: url('https://assets.website-files.com/65dc4e0e18107f1438dea07c/65dc4e0e18107f1438dea0b0_Inter-Bold.ttf') format('truetype');\n  font-weight: 700;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Inter';\n  src: url('https://assets.website-files.com/65dc4e0e18107f1438dea07c/65dc4e0e18107f1438dea0b1_Inter-SemiBold.ttf') format('truetype');\n  font-weight: 600;\n  font-style: normal;\n  font-display: swap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
